<template>
    <div class="candidate-audit">
        <!-- 页面标题 -->
        <div class="page-header">
            <h2 class="page-title">中标候选人公示审核</h2>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <label class="search-label">公告名称:</label>
                <el-input v-model="searchForm.announcementName" placeholder="请输入公告名称" class="search-input" clearable />

                <label class="search-label">公告状态:</label>
                <el-select v-model="searchForm.status" placeholder="请选择公告状态" class="search-input" clearable>
                    <el-option label="待审核" :value="1"></el-option>
                    <el-option label="已审核" :value="9"></el-option>
                </el-select>

                <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">
                    搜索
                </el-button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="bidSectionCode" label="标段编号" width="120" align="center" />
                <el-table-column prop="bidSectionName" label="标段名称" width="120" align="center" />
                <el-table-column prop="auditOpinion" label="审核意见" min-width="80" align="center" />

                <el-table-column prop="endTime" label="结束时间" width="160" align="center" />
                <el-table-column prop="publicTime" label="发布时间" width="160" align="center" />
                <el-table-column prop="status" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 0" type="info">暂存</el-tag>
                        <el-tag v-else-if="scope.row.status == 1" type="success">提交</el-tag>
                        <el-tag v-else-if="scope.row.status == 9" type="warning">发布</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="submitTime" label="提交时间" width="160" align="center" />
                <el-table-column prop="typeCode" label="公示类型" width="160" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.typeCode == 1" type="info">正常公示</el-tag>
                        <el-tag v-else-if="scope.row.typeCode == 2" type="success">更正</el-tag>
                        <el-tag v-else-if="scope.row.typeCode == 9" type="warning">其他</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="winCandidateBulletinCode" label="候选人公示编号" width="160" align="center" />
                <el-table-column prop="winCandidateBulletinName" label="候选人公示标题" width="160" align="center" />
                <el-table-column label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetails(scope.row)" class="action-btn">
                            详情
                        </el-button>
                        <el-button type="text" size="small" @click="handleViewStatus(scope.row)" class="action-btn"
                            v-if="searchForm.status === 1">
                            审核
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>


        <!-- 添加中标候选人公示弹窗 -->
        <el-dialog :title="status == 0 ? '新增中标候选人公示' : '查看中标候选人公示'" :visible.sync="dialogVisible" width="80%"
            :before-close="handleClose" :append-to-body="true" :close-on-click-modal="false"
            class="win-candidate-dialog">
            <div class="dialog-content">
                <el-form ref="candidateForm" :model="formData" label-width="180px" class="candidate-form">

                    <!-- 标段选择 -->
                    <el-form-item label="标段名称:" prop="bidSectionCode" required>
                        <el-select v-model="formData.bidSectionCode" placeholder="请选择标段" style="width: 100%"
                            :disabled="status == 1">
                            <el-option v-for="item in bidSectionList" :key="item.bidSectionCode"
                                :label="item.bidSectionName" :value="item.bidSectionCode">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 候选人公示标题 -->
                    <el-form-item label="候选人公示标题:" prop="winCandidateBulletinName" required>
                        <el-input v-model="formData.winCandidateBulletinName" placeholder="请输入候选人公示标题"
                            style="width: 100%" :disabled="status == 1">
                        </el-input>
                    </el-form-item>

                    <!-- 公示类型 -->
                    <el-form-item label="公示类型:" prop="typeCode" required>
                        <el-radio-group v-model="formData.typeCode" :disabled="status == 1">
                            <el-radio :label="1">正常公示</el-radio>
                            <el-radio :label="2">更正</el-radio>
                            <el-radio :label="9">其他</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <!-- 发布时间 -->
                    <el-form-item label="发布时间:" prop="publicTime" required>
                        <app-date-picker v-model="formData.publicTime" type="datetime" placeholder="选择发布时间"
                            style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" :disabled="status == 1">
                        </app-date-picker>
                    </el-form-item>

                    <!-- 结束时间 -->
                    <el-form-item label="结束时间:" prop="endTime" required>
                        <app-date-picker v-model="formData.endTime" type="datetime" placeholder="选择结束时间"
                            style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" :disabled="status == 1">
                        </app-date-picker>
                    </el-form-item>

                    <!-- 代理项目经理 -->
                    <el-form-item label="代理项目经理:" prop="agencyManager">
                        <el-input v-model="formData.agencyManager" placeholder="请输入代理项目经理姓名" style="width: 100%"
                            :disabled="status == 1">
                        </el-input>
                    </el-form-item>

                    <!-- 代理项目经理资质 -->
                    <el-form-item label="代理项目经理资质:" prop="agencyManagerCertification">
                        <el-input v-model="formData.agencyManagerCertification" placeholder="请输入代理项目经理资质"
                            style="width: 100%" :disabled="status == 1">
                        </el-input>
                    </el-form-item>

                    <!-- 代理项目经理身份证 -->
                    <el-form-item label="代理项目经理身份证:" prop="agencyManagerId">
                        <el-input v-model="formData.agencyManagerId" placeholder="请输入代理项目经理身份证号" style="width: 100%"
                            maxlength="18" :disabled="status == 1">
                        </el-input>
                    </el-form-item>

                    <!-- 全部投标人 -->
                    <el-form-item label="全部投标人:" prop="allBidders">
                        <el-input v-model="formData.allBidders" type="textarea" :rows="3" placeholder="请输入全部投标人信息"
                            style="width: 100%" :disabled="status == 1">
                        </el-input>
                    </el-form-item>

                    <!-- 否决投标人及理由 -->
                    <el-form-item label="否决投标人及理由:" prop="vetoBidderReason">
                        <el-input v-model="formData.vetoBidderReason" type="textarea" :rows="3"
                            placeholder="请输入否决投标人及理由" style="width: 100%" :disabled="status == 1">
                        </el-input>
                    </el-form-item>

                    <!-- 异议渠道或方式 -->
                    <el-form-item label="异议渠道或方式:" prop="complaints">
                        <el-input v-model="formData.complaints" type="textarea" :rows="2" placeholder="请输入异议渠道或方式"
                            style="width: 100%" :disabled="status == 1">
                        </el-input>
                    </el-form-item>

                    <!-- 候选人公示内容 -->
                    <el-form-item label="候选人公示内容:" prop="winCandidateBulletinContent" required>
                        <el-button type="success" style="margin-bottom: 5px;" :disabled="status == 1">
                            生成
                        </el-button>
                        <RichTextEditor v-model="formData.winCandidateBulletinContent" :height="400"
                            placeholder="请输入候选人公示内容..." toolbar-type="default" :disabled="status == 1" />
                    </el-form-item>

                    <!-- 附件 -->
                    <el-form-item label="附件:" prop="attachments">
                        <div class="attachment-section">
                            <div class="file-table">
                                <el-table :data="formData.uploadedFiles" style="width: 100%">
                                    <el-table-column prop="fileName" label="文件名"></el-table-column>
                                    <el-table-column prop="uploadTime" label="上传时间"></el-table-column>
                                    <el-table-column prop="uploadProgress" label="上传进度" width="120">
                                        <span>已完成</span>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">关 闭 </el-button>
            </span>
        </el-dialog>

        <!-- 审核弹窗 -->
        <el-dialog title="审核" :visible.sync="auditDialogVisible" width="500px" :before-close="handleAuditClose"
            :append-to-body="true" :close-on-click-modal="false">
            <el-form ref="auditForm" :model="auditForm" label-width="100px">
                <el-form-item label="审核意见:" prop="auditOpinion">
                    <el-input v-model="auditForm.auditOpinion" type="textarea" :rows="4" placeholder="请输入审核意见"
                        style="width: 100%">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleAuditClose">取 消</el-button>
                <el-button type="warning" @click="handleAuditSubmit(2)">退 回</el-button>
                <el-button type="success" @click="handleAuditSubmit(9)">通 过</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getWinCandidateBulletinList, getWinCandidateBulletinDetail, getWinCandidateBulletinCheck } from '@/api/agent/api'
import RichTextEditor from '@/components/common/RichTextEditor.vue'
import { getFileList } from '@/api/base/api'
export default {
    name: 'CandidateAudit',
    components: {
        RichTextEditor
    },
    data() {
        return {
            status: 1,
            loading: false,
            dialogVisible: false,
            auditDialogVisible: false,
            searchForm: {
                announcementName: '',
                status: 1
            },
            auditForm: {
                auditOpinion: '',
                tenderNoticeCode: '',
                winCandidateBulletinCode: ''
            },
            uploading: false,
            bidSectionList: [],
            tableData: [],
            formData: {},
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            currentAuditRow: null
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        // 加载数据
        loadData() {
            this.loading = true
            // 模拟数据加载
            setTimeout(() => {
                this.loading = false
            }, 500)
            this.getWinCandidateBulletinList()
        },
        //  获取列表
        getWinCandidateBulletinList() {
            getWinCandidateBulletinList(
                {
                    status: this.searchForm.status || 1,
                    pageNum: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize,
                    winCandidateBulletinName: this.searchForm.announcementName
                }

            ).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records
                    console.log(this.tableData);

                    this.pagination.total = res.data.total
                    this.pagination.currentPage = res.data.current
                } else {
                    this.$message.error(res.msg)

                }

            })

        },

        // 搜索
        handleSearch() {
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 查看详情
        handleViewDetails(row) {
            this.getWinCandidateBulletinDetail(row)
        },
        // 详情接口
        async getWinCandidateBulletinDetail(row) {
            getWinCandidateBulletinDetail(
                {
                    winCandidateBulletinCode: row.winCandidateBulletinCode
                }

            ).then(res => {
                if (res.code == 200) {
                    this.dialogVisible = true;
                    this.formData = res.data

                    this.getFileList(res.data.fileGuid)

                } else {
                    this.dialogVisible = false
                    this.$message.error(res.msg)
                }
            })
        },
        //获取文件
        async getFileList(fileGuid) {
            try {
                const res = await getFileList(fileGuid)
                if (res.code === 200) {
                    this.formData.uploadedFiles = res.data
                } else {
                    this.$message.error(res.msg || '获取文件列表失败')
                }
            } catch (error) {
                console.error('获取文件下载列表失败:', error)
                this.$message.error('获取文件下载列表失败，请重试')

            } finally { }

        },

        // 关闭弹窗
        handleClose() {
            this.dialogVisible = false
            this.resetForm()
        },

        // 查看状态
        handleViewStatus(row) {
            this.currentAuditRow = row
            this.auditForm.tenderNoticeCode = row.tenderNoticeCode || ''
            this.auditForm.winCandidateBulletinCode = row.winCandidateBulletinCode
            this.auditForm.auditOpinion = ''
            this.auditDialogVisible = true
        },

        // 关闭审核弹窗
        handleAuditClose() {
            this.auditDialogVisible = false
            this.auditForm = {
                auditOpinion: '',
                tenderNoticeCode: '',
                winCandidateBulletinCode: ''
            }
            this.currentAuditRow = null
        },

        // 提交审核
        handleAuditSubmit(status) {
            if (!this.auditForm.auditOpinion) {
                this.$message.warning('请输入审核意见')
                return
            }
            const params = {
                auditOpinion: this.auditForm.auditOpinion,
                status: status,
                tenderNoticeCode: this.auditForm.winCandidateBulletinCode,

            }
            getWinCandidateBulletinCheck(params).then(res => {
                if (res.code == 200) {
                    this.$message.success(status === 2 ? '退回成功' : '审核通过')
                    this.handleAuditClose()
                    this.loadData()
                } else {
                    this.$message.error(res.msg || '审核失败')
                }
            }).catch(err => {
                console.error('审核失败:', err)
                this.$message.error('审核失败，请重试')
            })
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
        // 重置表单
        resetForm() {
            this.formData = {
                projectCode: this.$route.query.projectCode || '',
                bidSectionCode: '',
                bidSectionName: '',
                winCandidateBulletinName: '',
                winCandidateBulletinContent: '',
                typeCode: 1,
                publicTime: '',
                startTime: '',
                endTime: '',
                agencyManager: '',
                agencyManagerCertification: '',
                agencyManagerId: '',
                allBidders: '',
                vetoBidderReason: '',
                complaints: '',
                fileGuid: '',
                uploadedFiles: [],
                status: 0
            }
            if (this.$refs.candidateForm) {
                this.$refs.candidateForm.clearValidate()
            }
        },
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common-page-styles.less';

.common-list-page-styles(candidate-audit);

.page-header {
    .warning-text {
        margin-left: 10px;
        color: #F56C6C;
        font-size: 14px;
        font-weight: 500;
    }
}
</style>
